import React, { useContext,  } from 'react';
// import { FaArrowRightLong } from "react-icons/fa6";
import { FormContext } from '../Provider';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';

export default function EditEmployement({ step, setStep }) {
    console.log("step:", step, "setStep:", setStep); // Debug line
    const navigate = useNavigate()
    const { editPersonal, setEditPersonal } = useContext(FormContext);
    // const api = process.env.REACT_APP_URL;

    let { id } = useParams();
    console.log("Student id", id); // Debug line


    // Revoke object URL on cleanup
    const validationCheck = () => {

        navigate(`/admin-forms/${id}`)
        setStep(step + 1);

    }
    console.log(editPersonal)

    return (

        <section className="bg-white  p-7">
            <div className="bg-gray-100 px-4 container py-5 h-100 flex justify-center items-start">
                <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-4xl">
                    <div className="font-bold text-lg text-primary-800">Employement Details</div>

                    <form className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">

                        {/* Checkbox - moved to top */}
                        <div className="col-span-1 md:col-span-2 flex items-center mt-2">
                            <input
                                type="checkbox"
                                id="currentlyWorking"
                                name="currentlyWorking"
                                checked={editPersonal.employmentInfo.isactive}
                                onChange={(e) =>
                                    setEditPersonal({
                                        ...editPersonal,
                                        employmentInfo: {
                                            ...editPersonal.employmentInfo,
                                            isactive: e.target.checked,
                                        },
                                    })
                                }
                                className="mr-2 w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-500"
                            />
                            <label htmlFor="currentlyWorking" className="text-gray-700 text-sm">
                                Are you currently employed?
                            </label>
                        </div>

                        {/* Company Name */}
                        <div className="relative w-full">
                            <input
                                type="text"
                                name="company"
                                id="company"
                                placeholder=" "
                                value={editPersonal.employmentInfo.companyName}
                                disabled={!editPersonal.employmentInfo.isactive}
                                onChange={(e) =>
                                    setEditPersonal({
                                        ...editPersonal,
                                        employmentInfo: {
                                            ...editPersonal.employmentInfo,
                                            companyName: e.target.value,
                                        },
                                    })
                                }
                                className="peer h-14 w-full px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            />
                            <label
                                htmlFor="company"
                                className="absolute left-4 px-1 bg-white text-base font-medium text-gray-500 transition-all duration-300 transform top-1/2 -translate-y-[2.6rem] scale-75 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[2.6rem] peer-focus:scale-75 peer-focus:text-blue-600"
                            >
                                Company Name
                            </label>
                        </div>

                        {/* Designation */}
                        <div className="relative w-full">
                            <input
                                type="text"
                                id="designation"
                                name="designation"
                                placeholder=" "
                                value={editPersonal.employmentInfo.designation}
                                disabled={!editPersonal.employmentInfo.isactive}
                                onChange={(e) =>
                                    setEditPersonal({
                                        ...editPersonal,
                                        employmentInfo: {
                                            ...editPersonal.employmentInfo,
                                            designation: e.target.value,
                                        },
                                    })
                                }
                                className="peer h-14 w-full px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            />
                            <label
                                htmlFor="designation"
                                className="absolute left-4 px-1 bg-white text-base font-medium text-gray-500 transition-all duration-300 transform top-1/2 -translate-y-[2.6rem] scale-75 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[2.6rem] peer-focus:scale-75 peer-focus:text-blue-600"
                            >
                                Designation
                            </label>
                        </div>

                        {/* Experience */}
                        <div className="relative w-full">
                            <input
                                type="number"
                                name="experience"
                                id="experience"
                                placeholder=" "
                                disabled={!editPersonal.employmentInfo.isactive}
                                value={editPersonal.employmentInfo.exp}
                                onChange={(e) =>
                                    setEditPersonal({
                                        ...editPersonal,
                                        employmentInfo: {
                                            ...editPersonal.employmentInfo,
                                            exp: Number(e.target.value),
                                        },
                                    })
                                }
                                className="peer h-14 w-full px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            />
                            <label
                                htmlFor="experience"
                                className="absolute left-4 px-1 bg-white text-base font-medium sm:text-base text-gray-500 transition-all duration-300 transform top-1/2 -translate-y-[2.6rem] scale-75 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[2.6rem] peer-focus:scale-75 peer-focus:text-blue-600"
                            >
                                Years Of Experience
                            </label>
                        </div>

                        {/* Location */}
                        <div className="relative w-full">
                            <input
                                type="text"
                                name="location"
                                id="location"
                                placeholder=" "
                                value={editPersonal.employmentInfo.companyLocation}
                                disabled={!editPersonal.employmentInfo.isactive}
                                onChange={(e) =>
                                    setEditPersonal({
                                        ...editPersonal,
                                        employmentInfo: {
                                            ...editPersonal.employmentInfo,
                                            companyLocation: e.target.value,
                                        },
                                    })
                                }
                                className="peer h-14 w-full px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            />
                            <label
                                htmlFor="location"
                                className="absolute left-4 px-1 bg-white text-base font-medium sm:text-base text-gray-500 transition-all duration-300 transform top-1/2 -translate-y-[2.6rem] scale-75 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[2.6rem] peer-focus:scale-75 peer-focus:text-blue-600"
                            >
                                Location
                            </label>
                        </div>

                        {/* Joined Date */}
                        <div className="relative w-full">
                            <input
                                type="date"
                                id="joineddate"
                                name="joineddate"
                                disabled={!editPersonal.employmentInfo.isactive}
                                value={
                                    editPersonal.employmentInfo.JoinedDate
                                        ? editPersonal.employmentInfo.JoinedDate.split("T")[0]
                                        : ""
                                }
                                onChange={(e) =>
                                    setEditPersonal({
                                        ...editPersonal,
                                        employmentInfo: {
                                            ...editPersonal.employmentInfo,
                                            JoinedDate: e.target.value ? e.target.value : null,
                                        },
                                    })
                                }
                                className="h-14 w-full px-4 py-2 peer rounded-lg text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-600"
                            />
                            <label
                                htmlFor="joineddate"
                                className="absolute top-0 left-4 -translate-y-1/2 px-1 bg-gray-50 text-xs font-medium text-gray-500"
                            >
                                Joined Date
                            </label>
                        </div>

                        {/* End Date */}
                        <div className="relative w-full">
                            <input
                                type="date"
                                id="enddate"
                                name="enddate"
                                disabled={!editPersonal.employmentInfo.isactive}
                                value={
                                    editPersonal.employmentInfo.EndDate
                                        ? editPersonal.employmentInfo.EndDate.split("T")[0]
                                        : ""
                                }
                                onChange={(e) =>
                                    setEditPersonal({
                                        ...editPersonal,
                                        employmentInfo: {
                                            ...editPersonal.employmentInfo,
                                            EndDate: e.target.value ? e.target.value : null,
                                        },
                                    })
                                }
                                className="h-14 w-full px-4 py-2 peer rounded-lg text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-600"
                            />
                            <label
                                htmlFor="enddate"
                                className="absolute top-0 left-4 -translate-y-1/2 px-1 bg-gray-50 text-xs font-medium text-gray-500"
                            >
                                End Date
                            </label>
                        </div>

                        {/* Buttons */}
                        <div className="col-span-1 md:col-span-2 flex flex-row sm:flex-row justify-between mt-6 gap-4">
                            <button
                                type="button"
                                className="w-full sm:w-auto py-2 px-4 rounded-md text-white text-base font-medium bg-primary-800 hover:bg-primary-700 flex items-center justify-center gap-2"
                                onClick={() => {
                                    navigate(`/admin-forms/${id}`);
                                    setStep(step - 1);
                                }}
                            >
                                Back
                            </button>

                            <button
                                type="button"
                                onClick={validationCheck}
                                className="w-full sm:w-auto py-2 px-4 rounded-md text-white text-base font-medium bg-primary-800 hover:bg-primary-700 flex items-center justify-center gap-2"
                            >
                                {editPersonal.employmentInfo.isactive ? "Next" : "Skip"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </section>

    );
}
